import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ClientsComponent } from './clients.component';
import { PartnerDocumentComponent } from './components/partner-document/partner-document.component';
import { ClientDetailsComponent } from './modals/client-details/client-details.component';

const routes: Routes = [
  { path: '', component: ClientsComponent },
  { path: 'details', component: ClientDetailsComponent },
  { path: 'partner-document', component: PartnerDocumentComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ClientsRoutingModule {}
